import { render } from "./Photo.vue?vue&type=template&id=231d86be&scoped=true&ts=true"
import script from "./Photo.vue?vue&type=script&lang=ts"
export * from "./Photo.vue?vue&type=script&lang=ts"

import "./Photo.vue?vue&type=style&index=0&id=231d86be&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-231d86be"]])

export default __exports__